const COMPACT_MQ = '(max-width: 1199.98px)'
export const TASK_MODAL_SHELL_CLASS = 'task-modal--flex-shell'

/** @returns {{ modal: HTMLElement, dialog: HTMLElement, extraClass?: string } | null} */
export function mountTaskModalShell({ modalEl, extraClass } = {}) {
  const modal = modalEl || document.getElementById('taskModal')
  const dialog = modal?.querySelector('.modal-dialog')
  if (!modal || !dialog) return null

  modal.classList.add(TASK_MODAL_SHELL_CLASS)
  if (extraClass) modal.classList.add(extraClass)

  const applyDialogMode = () => {
    if (window.matchMedia(COMPACT_MQ).matches) {
      dialog.classList.remove('modal-dialog-centered', 'modal-dialog-scrollable')
    } else if (!dialog.classList.contains('modal-dialog-centered')) {
      dialog.classList.add('modal-dialog-centered', 'modal-dialog-scrollable')
    }
  }

  applyDialogMode()
  const onResize = () => applyDialogMode()
  window.addEventListener('resize', onResize)

  return { modal, dialog, extraClass, onResize }
}

export function unmountTaskModalShell(shell) {
  if (!shell?.modal) return

  window.removeEventListener('resize', shell.onResize)
  shell.modal.classList.remove(TASK_MODAL_SHELL_CLASS)
  if (shell.extraClass) shell.modal.classList.remove(shell.extraClass)
  shell.dialog?.classList.add('modal-dialog-centered', 'modal-dialog-scrollable')
}
